import React from "react";

import Box from "@mui/material/Box";

import {
  StyledAddButton,
  StyledProductCard,
  StyledProductDescription,
  StyledProductImage,
  StyledProductName,
  StyledProductPieces,
  StyledProductPrice,
  StyledProductsRow,
  StyledSkeletonContainer,
  StyledTitleContainer,
  StyledTitleIcon,
  StyledTitleText,
} from "./index.style";

import { When } from "react-if";

interface ProductCarouselSkeletonProps {
  itemCount?: number;
  showIcon?: boolean;
}

const ProductCarouselSkeleton: React.FC<ProductCarouselSkeletonProps> = ({
  itemCount = 6,
  showIcon = true,
}) => {
  return (
    <StyledSkeletonContainer data-testid="skeleton-container">
      <StyledTitleContainer data-testid="title-container">
        <When condition={showIcon}>
          <StyledTitleIcon data-testid="title-icon" />
        </When>
        <StyledTitleText data-testid="title-text" />
      </StyledTitleContainer>
      <StyledProductsRow data-testid="products-row">
        {Array(itemCount)
          .fill(0)
          .map((_, index) => (
            <StyledProductCard key={index} data-testid="product-card">
              <Box position="relative" data-testid="product-box">
                <StyledProductImage data-testid="product-image" />
                <StyledAddButton data-testid="add-button" />
              </Box>
              <StyledProductName data-testid="product-name" />
              <StyledProductDescription data-testid="product-description" />
              <StyledProductPieces data-testid="product-pieces" />
              <StyledProductPrice data-testid="product-price" />
            </StyledProductCard>
          ))}
      </StyledProductsRow>
    </StyledSkeletonContainer>
  );
};

export default ProductCarouselSkeleton;
